import {
  ID_BACKLIGHT_TYPE_ATTRIBUTE,
  ID_COLLECTION_ATTRIBUTE,
  ID_HEIGHT_ATTRIBUTE,
  ID_WIDTH_ATTRIBUTE
} from '@shared/constants/keys';

import { useCharsManager } from '../../../../../hooks/useCharsManager';
import { CharItem } from '../CharItem/CharItem';

export const Mirrors = () => {
  const { props, onClickCollectionLink } = useCharsManager();
  return (
    <>
      {props[ID_COLLECTION_ATTRIBUTE] ? (
        <CharItem
          onClick={onClickCollectionLink}
          label={props[ID_COLLECTION_ATTRIBUTE]?.name}
          value={props[ID_COLLECTION_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
      {props[ID_WIDTH_ATTRIBUTE] ? (
        <CharItem
          label={props[ID_WIDTH_ATTRIBUTE]?.name}
          value={props[ID_WIDTH_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
      {props[ID_HEIGHT_ATTRIBUTE] ? (
        <CharItem
          label={props[ID_HEIGHT_ATTRIBUTE]?.name}
          value={props[ID_HEIGHT_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
      {props[ID_BACKLIGHT_TYPE_ATTRIBUTE] ? (
        <CharItem
          label={props[ID_BACKLIGHT_TYPE_ATTRIBUTE]?.name}
          value={props[ID_BACKLIGHT_TYPE_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
    </>
  );
};
